const linkers = {
    executive(id) {
        return `/executives/${id}`
    },
    company(id) {
        return `/companies/${id}`
    },
}

linkers.executives = linkers.executive
linkers.companies = linkers.company

Object.freeze(linkers)

const entityTypes = {
    company: 'Company',
    executive: 'Executive',
    getLink(entityType, entityId) {
        if (!entityType?.toLowerCase) {
            return null
        }

        const linker = linkers[entityType?.toLowerCase()]

        if (!linker) {
            return null
        }

        return linker(entityId)
    },
}

Object.freeze(entityTypes)

export default entityTypes
